import React, { forwardRef } from "react";
import { Form, Input } from "antd";

const InputText = forwardRef(({
  label,
  placeholder,
  name,
  disabled,
  min,
  max,
  pattern,
  type,
  required,
  size,
  value,
  onChange,
  onKeyPress,
  onClick,
  ...props
}, ref) => {
  const others = type !== 'integer' ? [
    { min: min, message: `Minimum length must be ${min}` },
    { max: max, message: `Maximum length must be ${max}` },
    { pattern: pattern?.allow, message: pattern?.message },
  ] : [];

  return (
    <Form.Item
      label={label}
      name={name}
      rules={[
        { required: required, message: `${label} is required!` },
        ...others
      ]}
      className="ant-form-item-custom-style"
    >
      <Input
        ref={ref}
        type={type || "text"}
        disabled={disabled}
        value={value}
        onClick={onClick}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={(e) => onKeyPress && onKeyPress(e)}
        placeholder={placeholder || label}
        size={size || "middle"}
        {...props}
      />
    </Form.Item>
  );
});

export default InputText;
